const getEquipmentFilterSummary = (equipmentFilter, translate) => equipmentFilter
  .map(item => translate(`equipment.${item}`))
  .reduce((prev, current) => (prev.length > 0 ? `${prev} & ${current}` : current), '');

export default getEquipmentFilterSummary;
